module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-backdrop",
    attrs: {
      "role": "dialog"
    }
  }, [_c('div', {
    directives: [{
      name: "on-clickaway",
      rawName: "v-on-clickaway",
      value: (_vm.away),
      expression: "away"
    }],
    ref: "modal",
    staticClass: "modal",
    attrs: {
      "aria-labelledby": "modalTitle",
      "aria-describedby": "modalDescription"
    }
  }, [_c('header', {
    staticClass: "modal-header",
    attrs: {
      "id": "modalTitle"
    }
  }, [_vm._t("header", [_vm._v("\n            " + _vm._s(_vm.modalHeading) + "\n            "), _c('button', {
    staticClass: "btn-close pull-right",
    attrs: {
      "type": "button",
      "aria-label": "Close modal"
    },
    on: {
      "click": _vm.close
    }
  }, [_c('i', {
    staticClass: "ti-close"
  })])])], 2), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "skeleton-loader"
  }, _vm._l((30), function(n) {
    return _c('div', {
      key: n,
      staticClass: "skeleton-row"
    })
  })) : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('section', {
    staticClass: "modal-body"
  }, [_vm._t("body", [_c('div', {
    attrs: {
      "align": "center"
    }
  }, [_c('h4', {
    staticStyle: {
      "margin": "10px 0 0"
    }
  }, [_vm._v(_vm._s(_vm.store_info.NAME))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.store_info.ADDRESS1)), _c('br'), _vm._v("\n                " + _vm._s(_vm.store_info.CITY) + ", " + _vm._s(_vm.store_info.STATE) + " " + _vm._s(_vm.store_info.RZIP))])]), _vm._v(" "), _c('table', {
    staticClass: "items-table"
  }, [_c('tbody', [_c('tr', [_c('td', [_c('b', [_vm._v("Item")])]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "60%"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right"
    }
  }, [_c('b', [_vm._v("Price")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right"
    }
  }, [_c('b', [_vm._v("Total")])])]), _vm._v(" "), _vm._l((_vm.order_items), function(item) {
    return _c('tr', [_c('td', {
      attrs: {
        "width": "25"
      }
    }, [_vm._v(_vm._s(item.QUANTITY) + " x")]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "60%"
      }
    }, [_vm._v(_vm._s(item.ITEM))]), _vm._v(" "), _c('td', {
      attrs: {
        "align": "right"
      }
    }, [_vm._v(_vm._s(item.ITEMTOTAL))]), _vm._v(" "), _c('td', {
      attrs: {
        "align": "right"
      }
    }, [_vm._v(_vm._s(item.ITEMSUBTOTAL))])])
  }), _vm._v(" "), _c('tr', {
    staticClass: "blank_row"
  }, [_c('td', {
    attrs: {
      "colspan": "3"
    }
  })]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "width": "60%"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right"
    }
  }, [_c('b', [_vm._v("Subtotal")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right"
    }
  }, [_vm._v(_vm._s(_vm.totals.ITEMSUBTOTAL))])]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "width": "60%"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right"
    }
  }, [_c('b', [_vm._v("Tax")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right"
    }
  }, [_vm._v(_vm._s(_vm.totals.ITEMTAX))])]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "width": "60%"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right"
    }
  }, [_c('b', [_vm._v("Order Total")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right"
    }
  }, [_vm._v(_vm._s(_vm.totals.TOTAL_AT))])])], 2)])])], 2) : _vm._e(), _vm._v(" "), _c('footer', {
    staticClass: "modal-footer"
  }, [_vm._t("footer", [_c('button', {
    staticClass: "btn btn-primary btn-fill btn-wd",
    on: {
      "click": _vm.close
    }
  }, [_vm._v(_vm._s(_vm.modalButtonText))])])], 2)])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2728a669!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UIComponents/OrderModal.vue
// module id = 356
// module chunks = 1